<script setup lang="ts">
import { instance as getApi } from '@/helpers/api'
import { errToStr } from '@/helpers/tools'
import { ref, type Ref } from 'vue'
import { formRules as rules } from '@/helpers/validators'
import KpTextfield from '@/components/kp-textfield.vue'

const mode = ref('register')
const valid = ref(false)
const error: Ref<string | null> = ref(null)
const loading = ref(false)
const formData = ref({
    email: '',
})

async function onSubmit() {
    error.value = null
    try {
        await getApi().post('/auth/register', formData.value)
        mode.value = 'confirmation'
    } catch (e) {
        error.value = errToStr(e)
    }
}
</script>

<template>
    <v-container>
        <v-fade-transition mode="out-in">
            <v-card
                v-if="mode === 'register'"
                class="trans-bg"
                max-width="600px"
                style="margin: auto; margin-top: 10rem; padding-left:1rem"
            >
                <v-card-title>{{ $t('register') }}</v-card-title>
                <v-card-text v-html="$t('register_lead_text')"> </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-form v-model="valid" @submit.stop="onSubmit">
                        <KpTextfield
                            v-model="formData.email"
                            :label="$t('emailaddress')"
                            placeholder="name@beispiel.com"
                            type="email"
                            autofocus
                            dense
                            :rules="[rules.required, rules.email]"
                        />
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="$router.go(-1)">{{ $t('back') }}</v-btn>
                    <v-btn
                        variant="flat"
                        color="primary"
                        type="submit"
                        :disabled="!valid || loading"
                        :loading="loading"
                        @click="onSubmit"
                    >
                        {{ $t('register') }}!
                    </v-btn>
                </v-card-actions>
                <v-slide-y-transition>
                    <v-alert v-if="error" type="error" dense tile>{{ error }}</v-alert>
                </v-slide-y-transition>
            </v-card>

            <v-card
                v-if="mode === 'confirmation'"
                class="trans-bg"
                max-width="600px"
                style="margin: auto; margin-top: 10rem"
            >
                <v-card-title>{{ $t('thanks') }}!</v-card-title>
                <v-card-text>
                    <p>
                        {{ $t('activation_mail_info', { email: formData.email }) }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn to="/" color="primary">{{ $t('back') }}</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-fade-transition>
    </v-container>
</template>

<style scoped>
.fancy {
    color: Tomato;
}
</style>
